<!--
 * @Description:
 * @Author: kangkang
 * @Date: 2022-08-08 17:23:56
 * @LastEditTime: 2024-05-02 21:46:50
 * @LastEditors: kangkang
 * @Reference:
-->
<template>
    <div class="record">
        <van-cell-group class="record-content record-user">
            <van-field
                v-model="form.username"
                label="逝者姓名"
                placeholder="请输入逝者姓名"
                input-align="right"
            />
            <van-field
                v-model="form.xhingshi"
                label="某府治丧"
                placeholder='【姓氏】'
                maxlength="2"
                input-align="right"
            >
                <template #extra>
                    <div style="font-size: 0.3rem;">
                        府治丧
                    </div>
                </template>
            </van-field>
            <van-field
                v-model="form.appellation"
                label="称谓选择"
                placeholder="请选择"
                input-align="right"
                right-icon="arrow"
                disabled
                @click="goName"
            />
        </van-cell-group>
        <div class="record-cell-group">
            <div class="list list-position">
                <div class="label">遗像照片</div>
                <div class="group">
                    <div class="text">{{ photoText }}</div>
                    <div class="todo">
                        <div class="record-switch">
                            <div
                                class="switch"
                                v-for="(item,index) in isPhoto"
                                :key="index"
                                :class="{
                                    'switch-active': currentPhoNum == index
                                }"
                                @click="choosePho(index)"
                            >{{ item }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="list list-position" v-if="currentPhoNum == 0">
                <div class="label">上传照片<span>（可以使用手指拖动调整照片位置）</span></div>
                <div class="group">
                    <div class="todo">
                        <div class="upload-list">
                            <!-- <img
                                v-show="form.pic"
                                class="show-img"
                                :class="{
                                    'black': form.pic_type == 1
                                }"
                                :src="form.pic" alt=""
                            /> -->
                            <van-uploader :after-read="afterRead">
                                <img
                                    :class="{
                                        'black': form.pic_type == 1
                                    }"
                                    class="upload-img"
                                    :src="form.pic ? form.pic : require('../../assets/record-upload.png')" alt=""
                                />
                            </van-uploader>
                        </div>
                    </div>
                </div>
            </div>
            <div class="list" v-if="currentPhoNum == 0">
                <div class="label">黑白模式切换</div>
                <div class="list-todo">
                    <van-switch v-model="form.pic_type" active-value="1" inactive-value="0" active-color="#A88E6E" inactive-color="#EBEBEB" @change="isBlackChange" />
                </div>
            </div>
        </div>
        <van-cell-group class="record-content record-photo">
            <van-field
                v-model="form.suspens_words_type"
                label="悼念词类型"
                input-align="right"
            >
                <template #input>
                    <div class="record-switch record-switchbig">
                        <div
                            class="switch"
                            v-for="(item,index) in daociType"
                            :key="index"
                            :class="{
                                'switch-active': currentTypeNum == index
                            }"
                            @click="daociTypleClick(index)"
                        >{{ item }}</div>
                    </div>
                </template>
            </van-field>
            <van-field
                v-model="form.suspens_words"
                right-icon="arrow"
                label="悼词选择"
                placeholder="请选择"
                input-align="right"
                disabled
                @click="goDaoci"
            />
<!--            <van-field-->
<!--                v-model="form.chubin_time"-->
<!--                right-icon="arrow"-->
<!--                label="出殡时间"-->
<!--                placeholder="请选择"-->
<!--                input-align="right"-->
<!--                disabled-->
<!--                @click="goPicker"-->
<!--            />-->
            <van-field
                v-model="hallname"
                label="厅名称"
                placeholder="请输入厅名称"
                input-align="right"
                disabled
            />
        </van-cell-group>
        <div class="record-cell-group">
            <div class="list list-position">
                <div class="label">背景选择</div>
                <div class="group">
                    <div class="video-list">
                        <div
                            class="list-v"
                            v-for="(item,index) in videoArr"
                            :key="index"
                        >
                            <img v-if="currentVideoNum && currentVideoNum == index" class="list-v-active" src="../../assets/record-bac-active.png" />
                            <video
                                ref="video"
                                :src="item.thumb"
                                loop
                                webkit-playsinline="true"
                                playsinline="true"
                                x-webkit-airplay="allow"
                                x5-playsinline
                                style="width: 100%;height: 100%"
                                :autoplay="false"
                                :poster="item.pic"
                                muted="true"
                                @click="videoClick(item,index)"
                            >
                            </video>
                            <!-- <img
                                class="video-poster"
                                src="../../assets/poster.png" alt=""
                                v-if="currentVideoNum && currentVideoNum == index ? false : true"
                            /> -->
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="record-bottom">
            <div class="record-bottom-btn" @click="goVideo">点击预览</div>
        </div>
        <daoci-com
            v-if="isDaoci"
            :title="daocititle"
            :data="dataArr"
            @daociConfirm="daociConfirm"
            @daociCancel="daociCancel"
        ></daoci-com>
        <time-com
            v-if="timePicker"
            :timeshow="timePicker"
            @timerConfirm="timerConfirm"
            @timerCancel="timerCancel"
        ></time-com>
        <imagecropper-com
            :visible="cropperVisible"
            :url="imgUrl"
            :file-info="fileInfo"
            @cancel="cropperVisible = false"
            @success="cropperSuccess"
        >

        </imagecropper-com>
    </div>
</template>
<script>
import DaociCom from '../../components/daoci.component.vue';
import ImagecropperCom from '../../components/Imagecropper.component.vue';
import TimeCom from '../../components/time.component.vue';
import {Toast} from "vant";

export default {
    name: "record",
    data() {
        return {
            isDaoci: false,//悼词，称谓选择
            timePicker: false, //时间选择
            cropperVisible: false,
            imgUrl: "",
            fileInfo: {},
            value1: "",
            value2: "",
            checked: true,
            daocititle: "",
            dataArr: [],
            videoArr: [],
            isPhoto: ["有","无"],
            daociType: ["通用版","其他"],
            video: "",
            form: {
                suspens_words_type: 0,
                pic: "",
                pic_type: "0",
                hall_id: sessionStorage.hallid,
            },
            photoText: "请上传一张遗像照",
            currentPhoNum: 0,//是否上传遗照索引
            currentTypeNum: 0,//悼词类型索引
            currentVideoNum: "",//选择背景视频
            hallname: sessionStorage.hall_name,//厅名称
            isShowPoster: true
        };
    },
    components: {
        DaociCom,
        TimeCom,
        ImagecropperCom
    },
    computed: {},
    methods: {
        // 打开称谓选择
        goName() {
            this.$utils.checkToken().then(res=>{
                this.doGetAppellationList();
            })
        },
        // 点击是否上传遗照
        choosePho(index) {
            if(index == 0){
                this.photoText = "请上传一张遗像照";
            }else{
                this.photoText = "系统将自动生成用户指定背景进入无照片播放模式";
            }
            this.currentPhoNum = index;
        },
        // 悼词类型
        daociTypleClick(index) {
            this.currentTypeNum = index;
            this.form.suspens_words_type = index;
            this.form.suspens_words = '';
            this.form.suspens_words_id = null;
        },
        // 打开悼词选择
        goDaoci() {
            this.daocititle = "悼念词"
            this.isDaoci = true;
            this.$utils.checkToken().then(res=>{
                this.doGetSuspensiveWordsList();
            })
        },
        // 打开时间选择器
        goPicker() {
            this.timePicker = true;
        },
        // 选择视频背景
        videoClick(item,index) {
            console.log(item,this.$refs)
            this.$refs.video[index].play();
            this.form.backvideo_id = item.id;
            this.form.backvideo = item.thumb;
            this.currentVideoNum = index + "";
            this.form.backpic = item.pic;
        },
        // 打开预览视频页面
        judgeText(text, msg) {
          if (!text) {
              this.$dialog.toast(msg);
              return false;
          }
          return true;
        },
        goVideo() {
            //判空处理
            console.log(this.form, this.currentPhoNum);
            if (!this.judgeText(this.form.username, "请输入逝者姓名")) {
                return;
            }
            if (!this.judgeText(this.form.xhingshi, "请输入姓氏")) {
                return;
            }
            if (!this.judgeText(this.form.appellation_id, "请选择称谓")) {
                return;
            }
            if (!this.judgeText(this.form.appellation, "请选择称谓")) {
                return;
            }
            //先判断是否需要上传照片
            if (this.currentPhoNum == 0) {//有照片
                if (!this.judgeText(this.form.pic, "请上传图片")) {
                    return;
                }
            }
            if (!this.judgeText(this.form.suspens_words_id, "请选择悼念词")) {
                return;
            }
            if (!this.judgeText(this.form.suspens_words, "请选择悼念词")) {
                return;
            }
            // if (!this.judgeText(this.form.chubin_time, "请选择出殡时间")) {
            //     return;
            // }
            if (!this.judgeText(this.form.hall_id, "厅信息异常，请重新扫码")) {
                return;
            }
            if (!this.judgeText(this.form.backvideo_id, "请选择背景")) {
                return;
            }
            if(this.currentPhoNum == 1){
                if(this.form.pic){
                    this.form.pic = "";
                    this.form.pic_type = "";
                }
            }
            this.$router.push({
                name: 'prevideo',
                query: {
                    data: JSON.stringify(this.form)
                }
            })
        },
        // 获取称谓关系接口
        doGetAppellationList() {
            this.$api.index.getAppellationList().then(res => {
                this.dataArr = res;
                this.daocititle = "称谓关系";
                this.isDaoci = true;
            })
        },
        // 获取悼念词列表
        doGetSuspensiveWordsList() {
            this.$api.index.getSuspensiveWordsList({type: this.form.suspens_words_type}).then(res => {
                this.dataArr = res;
                this.daocititle = "悼念词";
            })
        },
        // 获取视频列表
        doGetBackVideoList() {
            this.$api.index.getBackVideoList().then(res => {
                res.forEach((el,index) => {
                    if(el.id == this.form.backvideo_id){
                        this.currentVideoNum = index + "";
                    }
                });


                this.$nextTick(() => {
                    this.videoArr = res;
                })
            })
        },
        // 选择黑白照片
        isBlackChange(val) {
            console.log("++", typeof val)
        },
        // 图片上传
        afterRead(file) {
            //图片加载完成 进行裁剪
            file = file.file;
            console.log(file)
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                //显示裁剪框
                this.imgUrl = fileReader.result;
                //将文件信息传过去
                this.fileInfo = {
                    name: file.name,
                    suffix: file.name.substring(file.name.lastIndexOf(".") + 1)
                };
            }
            this.cropperVisible = true;
        },
        // 图片裁剪
        cropperSuccess(file) {
            let result = new File([file], 'file.jpeg', {type: 'image/jpeg', lastModified: Date.now()});
            let formDatas = new FormData();
            formDatas.append("_file_",result);
            this.cropperVisible = false;
            let self = this;
            this.$api.index.uploadImage(formDatas).then(res => {
                self.form.pic = res.url;
            })
        },
        // 时间
        timerConfirm(val) {
            console.log(val)
            this.timePicker  = val.show;
            this.form.chubin_time = val.time;
        },
        timerCancel(val) {
            console.log(val)
            this.timePicker  = val;
        },
        // 悼词，称谓关系
        daociConfirm(val) {
            if(this.daocititle == "悼念词"){
                this.form.suspens_words_id = val.json.value;
                this.form.suspens_words = val.json.name;
            }else{
                this.form.appellation_id = val.json.id;
                this.form.appellation = val.json.name;
                this.form.appellation_status = val.json.status;
            }
            this.isDaoci = val.show;
        },
        daociCancel(val) {
            this.isDaoci = val;
        },

    },

    mounted() {
        //  this.$nextTick(() => {
        //     const video = document.getElementById('videoId')
        //     console.log(video)
        //     // 一般情况下，这样就可以自动播放了，但是一些奇葩iPhone机不可以
        //     this.$refs.video.play()
        //     // 必须在微信Weixin JSAPI的WeixinJSBridgeReady才能生效
        //     document.addEventListener('WeixinJSBridgeReady', () => {
        //         this.$refs.video.play()
        //     },false)
        // })
    },
    created() {
        if(this.$route.query.data){
            this.form = JSON.parse(this.$route.query.data);
            this.form.pic_type = this.form.pic_type + "";
        }
        if(sessionStorage.form){
            this.form = JSON.parse(sessionStorage.form);
        }
        if(this.form.suspens_words_type == "0"){
            this.currentTypeNum = "0";
        }else{
            this.currentTypeNum = "1";
        }
        if(this.form.pic){
            this.currentPhoNum = 0;
        }
        if (this.form.hall) {
            this.hallname = this.form.hall;
        }
        this.$utils.checkToken().then(res=>{
            this.doGetBackVideoList();
            this.doGetSuspensiveWordsList();
        })
    },
    watch: {

    },
};
</script>
<style rel="stylesheet/scss" lang="scss">
// .van-pull-refresh {
//     height: 100vh;
// }
.van-loading {
    margin: 0 auto;
    width: px2rem(200);
}
.van-popup {
    background: inherit;
}
.van-popup--bottom {
    left: 0;
}
.record {
    position: relative;
    width: 100%;
    min-height: 100%;
    background: #F4F4F4;
    padding-top: px2rem(20);
    padding-bottom: px2rem(132);
    .van-hairline--top-bottom::after {
        border-width: 0;
    }
    .van-cell:not(:last-child)::after {
        right: 15px;
        border-bottom: 1px solid #EDEDED;
    }
    .van-field__label {
        font-size: px2rem(30);
        color: #000000;
    }
    .van-field__control {
        font-size: px2rem(30);
        color: #000000;
    }
    .van-field__control {
        font-size: px2rem(30);
    }
    .van-field__right-icon {
        padding: 0 0 0 px2rem(24);
    }
    &-content {
        margin-bottom: px2rem(20);
    }
    &-cell-group {
        background: #ffffff;
        margin-bottom: px2rem(20);
        position: relative;
        .list {
            font-size: px2rem(30);
            padding: px2rem(28) 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            &:not(:last-child)::after {
                content: ' ';
                position: absolute;
                pointer-events: none;
                box-sizing: border-box;
                left: 0;
                right: 0;
                bottom: 0;
                transform: scaleY(.5);
                border-bottom: 1px solid #EDEDED;
            }
            &-todo {
                padding-right: px2rem(28);
                .van-switch {
                    font-size: px2rem(36);
                    margin-left: px2rem(64);
                    margin-top: px2rem(28);
                }
            }
            // border-bottom: 1px solid #EDEDED;
            .label {
                color: #000000;
                padding-left: px2rem(28);
                span {
                    font-size: px2rem(24);
                    color: #808080;
                }
            }
            .group {
                display: flex;
                justify-content: space-between;
                .text {
                    font-size: px2rem(22);
                    color: #808080;
                    padding-left: px2rem(28);
                    margin-top: px2rem(10);
                    margin-right: px2rem(18);
                    line-height: px2rem(34);
                }
                .todo {
                    padding-right: px2rem(28);
                    .record-switch {
                        margin-top: px2rem(-20);
                    }
                    .upload-list {
                        margin-top: px2rem(20);
                        display: flex;
                        align-items: center;
                        .black {
                            filter: grayscale(100%);
                            -webkit-filter: grayscale(100%);
                            -moz-filter: grayscale(100%);
                            -ms-filter: grayscale(100%);
                            -o-filter: grayscale(100%);
                        }
                        .show-img {
                            display: block;
                            width: px2rem(176);
                            height: px2rem(235);
                            margin-left: px2rem(28);
                            border-radius: px2rem(8);
                        }
                        .upload-img {
                            display: block;
                            width: px2rem(176);
                            height: px2rem(235);
                            margin-left: px2rem(28);
                        }
                    }


                }
                .video-list {
                    display: flex;
                    align-items: center;
                    flex-flow: wrap;
                    .list-v {
                        width: px2rem(222);
                        height: px2rem(322);
                        margin-left: px2rem(24);
                        margin-top: px2rem(20);
                        position: relative;
                        &-active {
                            display: block;
                            width: px2rem(222);
                            height: px2rem(322);
                            position: absolute;
                            left: 0;
                            top: 0;
                        }
                        video {
                            display: block;
                            width: 100%;
                            height: 100%;
                            border-radius: px2rem(30);
                            overflow: hidden;
                        }
                        .video-poster {
                            display: block;
                            width: px2rem(60);
                            height: px2rem(60);
                            position: absolute;
                            left: 38%;
                            top: 45%;
                            z-index: 99;
                        }
                    }
                    & > .list-v:nth-child(1) {
                        margin-left: px2rm(-20);
                    }
                }
            }
        }
        .list-position {
            display: block;
        }

    }
    &-switch {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #EBEBEB;
        font-size: px2rem(28);
        color: #8E8E8E;
        width: px2rem(208);
        height: px2rem(64);
        border-radius: px2rem(32);
        .switch {
            width: 50%;
            height: px2rem(64);
            text-align: center;
            line-height: px2rem(64);
            border-radius: px2rem(32);
        }
        .switch-active {
            background: #A88E6E;
            color: #ffffff;
        }
    }
    &-switchbig {
        width: px2rem(262);
    }
    &-bottom {
        position: fixed;
        left: 0;
        bottom: 0;
        background: #ffffff;
        width: 100%;
        height: px2rem(132);
        display: flex;
        align-items: center;
        font-size: px2rem(30);
        color: #ffffff;
        box-sizing: border-box;
        padding: px2rem(20) px2rem(32);
        &-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            background: #A88E6E;
        }
    }
}
</style>
